import React from 'react';
import AddSubfolder from '../../../assets/icons/folders/add_subfolder.svg';
import Rename from '../../../assets/icons/rename.svg';
import Trash from '../../../assets/icons/trash_raw.svg';
import Settings from '../../../assets/images/dashboard/settings.png';
import HoverButton from '../../base/HoverButton';
import PopupMenuButton from '../PopupMenuButton';
import AddFlowButton from './AddFlowButton';
import AddFormButton from './AddFormButton';
import AddSegmentButton from './AddSegmentButton';
import styles from './listWithFolders.module.scss';

const FolderSettingsButton = ({
  folder,
  addSubfolder,
  renameFolder,
  deleteFolder,
  type,
}) => {
  const handleAddSubfolder = (e) => {
    e.stopPropagation();
    if (addSubfolder) {
      addSubfolder(folder);
    }
  };

  const handleRenameFolder = (e) => {
    e.stopPropagation();
    if (renameFolder) {
      renameFolder(folder);
    }
  };

  const handleDeleteFolder = (e) => {
    e.stopPropagation();
    if (deleteFolder) {
      deleteFolder(folder);
    }
  };

  return (
    <HoverButton
      buttonContent={
        <img
          src={Settings}
          className="cursor-pointer"
          height="25"
          width="25"
          alt="settings"
        />
      }
    >
      <>
        {renameFolder && (
          <PopupMenuButton onClick={(e) => handleRenameFolder(e)}>
            <Rename />
            Rename
          </PopupMenuButton>
        )}
        {addSubfolder && (
          <PopupMenuButton key={2} onClick={(e) => handleAddSubfolder(e)}>
            <AddSubfolder color="#90A0B7" />
            Add subfolder
          </PopupMenuButton>
        )}
        {type === 'audiences' && <AddSegmentButton folderId={folder.id} />}
        {type === 'flows' && <AddFlowButton folderId={folder.id} />}
        {type === 'forms' && <AddFormButton folderId={folder.id} />}
        {deleteFolder && (
          <PopupMenuButton
            key={3}
            onClick={(e) => handleDeleteFolder(e)}
            className={styles.deleteButton}
          >
            <Trash />
            Delete
          </PopupMenuButton>
        )}
      </>
    </HoverButton>
  );
};

export default FolderSettingsButton;
